import React from "react";

export const StatusDot = ({ color = "#39FF14", pulse = false }) => (
    <span
        className={`dot ${pulse ? "dot-pulse" : ""}`}
        style={{ background: color, boxShadow: `0 0 8px ${color}` }}
    />
);

export const Panel = ({ title, right, children, className = "", testId }) => (
    <div className={`border border-border bg-card ${className}`} data-testid={testId}>
        {title && (
            <div className="flex items-center justify-between border-b border-border px-4 py-3">
                <span className="label">{title}</span>
                {right}
            </div>
        )}
        <div className="p-4">{children}</div>
    </div>
);

export const Stat = ({ label, value, sub, accent = false, testId }) => (
    <div className="border border-border bg-card p-5 relative overflow-hidden" data-testid={testId}>
        <div className="label mb-3">{label}</div>
        <div
            className="font-head text-3xl sm:text-4xl leading-none"
            style={accent ? { color: "hsl(var(--primary))" } : {}}
        >
            {value}
        </div>
        {sub && <div className="mt-2 text-xs text-muted-foreground">{sub}</div>}
    </div>
);

export const Verdict = ({ v }) => {
    const map = {
        green: { c: "#39FF14", t: "ÓPTIMO" },
        yellow: { c: "#FFD700", t: "REVISAR" },
        red: { c: "#FF003C", t: "BAJO" },
        pending: { c: "#00FFFF", t: "PROCESANDO" },
    };
    const m = map[v] || map.yellow;
    return (
        <span
            className="inline-flex items-center gap-2 text-[10px] tracking-wider uppercase px-2 py-1 border"
            style={{ color: m.c, borderColor: m.c }}
        >
            <StatusDot color={m.c} /> {m.t}
        </span>
    );
};

export const Btn = ({ children, onClick, variant = "primary", disabled, testId, className = "", type = "button" }) => {
    const styles = {
        primary: "bg-primary text-primary-foreground hover:bg-primary/80",
        ghost: "bg-transparent text-foreground border border-border hover:bg-secondary",
        danger: "bg-transparent text-destructive border border-destructive hover:bg-destructive hover:text-white",
        green: "bg-transparent border hover:opacity-80",
    };
    return (
        <button
            type={type}
            data-testid={testId}
            disabled={disabled}
            onClick={onClick}
            style={variant === "green" ? { color: "#39FF14", borderColor: "#39FF14" } : {}}
            className={`px-4 py-2 text-xs uppercase tracking-wider font-medium transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed ${styles[variant]} ${className}`}
        >
            {children}
        </button>
    );
};

export const PageHead = ({ title, sub }) => (
    <div className="mb-6">
        <h1 className="font-head text-3xl sm:text-4xl">{title}</h1>
        {sub && <p className="mt-2 text-sm text-muted-foreground max-w-2xl">{sub}</p>}
    </div>
);
